export default __webpack_public_path__ + "static/media/liquidate_main.8a3910ae.png";